import { withInstall } from '@hd-front-end/utils'
import PageHeader from './src/page-header.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElPageHeader: SFCWithInstall<typeof PageHeader> =
  withInstall(PageHeader)
export default ElPageHeader

export * from './src/page-header'
